import type { FireflyRuntime, Route } from "@sg-protect/federation-runtime";
import { AuthenticatedLayout, requireFeatureFlagLoader } from "@sg-protect/shell";
import { FullScreenHomeAuthenticatedLayout } from "./components/FullScreenHomeAuthenticatedLayout.tsx";
import { PartnerDashboardLayout } from "./features/partners/PartnerDashboardLayout.tsx";
import { PartnerLayout } from "./features/partners/PartnerLayout.tsx";
import { HomeEntryRedirect } from "./components/workspace/HomeEntryRedirect.tsx";
import { HomeZeroStateGate } from "./components/workspace/HomeZeroStateGate.tsx";
import { getPaths } from "./paths.ts";

export const registerPublicRoutes = (): Route[] => [];

export const registerPrivateRoutes = (runtime: FireflyRuntime): Route[] => {
    const paths = getPaths();
    return [
        {
            path: paths.entry,
            element: <HomeEntryRedirect />
        },
        {
            path: paths.root,
            element: <HomeEntryRedirect />
        },
        {
            element: <AuthenticatedLayout />,
            children: [
                {
                    element: <HomeZeroStateGate />,
                    children: [
                        {
                            path: paths.homeZeroState,
                            lazy: () => import("./pages/home-zero-state.tsx"),
                            handle: {
                                trackingName: "Home Get Started",
                                pageTitle: "Get Started",
                                isZeroState: true
                            }
                        }
                    ]
                },
                {
                    path: paths.homeRestrictedState,
                    lazy: () => import("./pages/home-restricted-state.tsx"),
                    handle: {
                        trackingName: "Home Get Started",
                        pageTitle: "Home",
                        isRestrictedState: true
                    }
                }
            ]
        },
        {
            element: <PartnerDashboardLayout />,
            children: [
                {
                    path: paths.partnerDashboard,
                    lazy: () => import("./pages/partner/dashboard.tsx"),
                    handle: { trackingName: "Partner Hub", pageTitle: "Home" }
                }
            ]
        },
        {
            element: <PartnerLayout isDistractionFree />,
            children: [
                {
                    path: paths.createClientWorkspace,
                    lazy: () => import("./pages/partner/create-workspace.tsx"),
                    handle: { trackingName: "Create Client Workspace", pageTitle: "Create client workspace" }
                }
            ]
        },
        {
            element: <AuthenticatedLayout />,
            loader: () => requireFeatureFlagLoader(runtime, "NewPricingV2Released"),
            children: [
                {
                    path: paths.billingSubscriptions,
                    lazy: () => import("./pages/billing/subscriptions.tsx"),
                    handle: { trackingName: "Billing Subscriptions", pageTitle: "Subscriptions" }
                }
            ]
        },
        {
            element: <FullScreenHomeAuthenticatedLayout isDistractionFree />,
            loader: () => requireFeatureFlagLoader(runtime, "NewPricingV2Released"),
            children: [
                {
                    path: paths.billingCheckout,
                    lazy: () => import("./pages/billing/checkout.tsx"),
                    handle: { trackingName: "Billing Checkout", pageTitle: "Billing" }
                },
                {
                    path: paths.billingComplete,
                    lazy: () => import("./pages/billing/complete.tsx"),
                    handle: { trackingName: "Billing Checkout Complete", pageTitle: "Checkout complete" }
                }
            ]
        }
    ];
};
